import React, { useEffect } from 'react';

import {
  useInterestsState,
  useInterestsActions,
} from './InterestsContext';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { createUnrecognizedInterest, getInterests } from './restApi';

const NewUnrecognizedInterestForm = () => {
  const state = useInterestsState();
  const { onResponse, onError, updateDebouncedInterestNameForFuzzyFilter, updateNewInterestName } = useInterestsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  useEffect(() => {
    const handler = setTimeout(() => {
      updateDebouncedInterestNameForFuzzyFilter(state?.newUnrecognizedInterestForm?.interestName);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [state?.newUnrecognizedInterestForm?.interestName]);

  useEffect(() => {
    getInterests({
      onResponse,
      onError,
      pageNumber: 1,
      debouncedInterestNameForFuzzyFilter: state?.newUnrecognizedInterestForm?.debouncedInterestNameForFuzzyFilter,
    });
  }, [state?.newUnrecognizedInterestForm?.debouncedInterestNameForFuzzyFilter]);

  const handleSubmit = () => {
    createUnrecognizedInterest({
      onResponse,
      onError,
      body: {
        newUnrecognizedInterestForm: state?.newUnrecognizedInterestForm,
        authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Interest Name" id="interestName">
        <Input
          type="text"
          placeholder="Search Interest And Add If Not Found..."
          value={state?.newUnrecognizedInterestForm?.interestName}
          onChange={(e) => updateNewInterestName(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button type="submit">
            Add Interest
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default NewUnrecognizedInterestForm;
